<ejs-dialog #dialog
            [isModal]="true"
            [ngClass]="{'hide-footer': !modalDialog?.showFooter}"
            [showCloseIcon]="true"
            [visible]="false"
            (close)="onClose($event)">
  <ng-template #header>
    {{modalDialog?.title | translate}}
  </ng-template>

  <ng-template #content>
    <div [innerHTML]="modalDialog?.message | translate">
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    @if (modalDialog?.showFooter) {
      <button class="e-control e-btn e-lib e-flat"
              (click)="cancelClicked()">{{'i18n.shared.cancel' | translate}}</button>
      <button class="e-control e-btn e-lib e-primary e-flat"
              (click)="okClicked()">{{'i18n.shared.ok' | translate}}</button>
    }
  </ng-template>
</ejs-dialog>
